class CacheError extends Error {
}

class KeyAlreadyExists extends CacheError {
	constructor(key) {
		super(`Key already exists: ${key}`);
	}
}

class NotFound extends CacheError {
	constructor(key) {
		super(`Key not found: ${key}`);
	}
}

export default class Cache {

	_factory = null;
	_validator = null;
	_canOverwrite = null;
	_cache = null;

	constructor(factory = null, validator = null, canOverwrite = false) {
		this._factory = factory;
		this._validator = validator;
		this._canOverwrite = canOverwrite;
		this._cache = new Map();
	}

	put(key, value) {
		this._validate(key, value);
		if (!this._canOverwrite && this._cache.has(key)) {
			throw new KeyAlreadyExists(key);
		}
		this._cache.set(key, value);
	}

	get(key, defaultValue = void 0) {
		let value = this._cache.get(key);
		if (value === void 0 && !this._cache.has(key)) {
			if (this._factory) {
				value = this._factory(key);
				this.put(key, value);
			} else if (defaultValue !== void 0) {
				value = defaultValue;
			} else {
				throw new NotFound(key);
			}
		}
		return value;
	}

	remove(key) {
		this._cache.delete(key);
	}

	_validate(key, value) {
		if (typeof key !== 'string' || !key.length) {
			throw new Error('Invalid/empty key');
		}
		if (this._validator) {
			this._validator(key, value);
		}
	}

}
